import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const WalletIconLedger: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill={colors['--pink-500']}
      d="M11.875 6.75v-4.5a.5.5 0 00-.5-.5h-6.75a.5.5 0 00-.5.5v4.5c-1.034 0-1.875.814-1.875 1.813v5.562c0 .069.056.125.125.125h.875a.125.125 0 00.125-.125V8.562c0-.38.337-.687.752-.687h7.746c.415 0 .752.308.752.688v5.562c0 .069.056.125.125.125h.875a.125.125 0 00.125-.125V8.562c0-.998-.84-1.812-1.875-1.812zm-6.625 0V2.875h5.5V6.75h-5.5zm1.875-2.875h-.75A.125.125 0 006.25 4v.75c0 .069.056.125.125.125h.75a.125.125 0 00.125-.125V4a.125.125 0 00-.125-.125zm2.5 0h-.75A.125.125 0 008.75 4v.75c0 .069.056.125.125.125h.75a.125.125 0 00.125-.125V4a.125.125 0 00-.125-.125z"
    />
  </svg>
);

export default WalletIconLedger;
